import { useParams, Routes, Route, Navigate } from 'react-router-dom'
import { gql } from 'graphql-request'

import { useQuery } from '@hooks/graphql'
import { Route as RouteIcon, Bot } from 'lucide-react'

import Breadcrumbs from '@components/Breadcrumbs'
import Spinner from '@components/Spinner'
import NavTabs from '@components/NavTabs'
import { Badge } from '@components/ui/badge'

import CoursesList from './CoursesList'
import TutorAssignmentList from './TutorAssignmentList'
import useResearchConsent from '../../hooks/useResearchConsent'

const CLASSROOM_QUERY = gql`
  query classroom($id: ID!) {
    classroom(id: $id) {
      id
      name
      archived
      educator {
        id
        email
        fullName
      }
    }
  }
`

const ClassroomDetails = () => {
  const { id } = useParams()
  const { isLoading: isCheckingResearchConsent } = useResearchConsent(id)

  const {
    isLoading,
    data: { classroom = {} } = {}
  } = useQuery({
    queryKey: ['classroom', id],
    gqlQuery: CLASSROOM_QUERY,
    variables: { id }
  })

  return (
    <>
      <Breadcrumbs>
        <Breadcrumbs.Link label='Classrooms' to='/students/classrooms' />
        <Breadcrumbs.Text label={classroom.name} />

        <If condition={classroom.archived}>
          <Badge variant='outline'>
            Archived
          </Badge>
        </If>
      </Breadcrumbs>

      <Choose>
        <When condition={isCheckingResearchConsent || isLoading}>
          <Spinner className='relative left-0 top-0 flex h-screen w-full items-center justify-center' />
        </When>

        <Otherwise>
          <h1 className='text-2xl font-bold text-foreground mx-5 my-4'>{classroom.name}</h1>

          <NavTabs className='mx-5'>
            <NavTabs.Link
              to='courses'
              end
              icon={<RouteIcon size={16} />}
              label='Pathways'
            />
            <NavTabs.Link
              to='tutors'
              end
              icon={<Bot size={16} />}
              label='Tutors'
            />
          </NavTabs>

          <Routes>
            <Route
              index
              element={<Navigate to="courses" replace />}
            />

            <Route
              path='courses'
              element={<CoursesList id={id} />}
            />

            <Route
              path='tutors'
              element={<TutorAssignmentList id={id} />}
            />
          </Routes>

        </Otherwise>
      </Choose>
    </>
  )
}

export default ClassroomDetails
